'use strict'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import $ from 'jquery'
import slick from 'slick-carousel'

export default () => {
}

$('.works__sec02__form h2').on('click', function () {
  $(this).toggleClass('open')
  $(this).next().slideToggle()
  return false
})
$('.c-qa dt').on('click', function () {
  $(this).toggleClass('open')
  $(this).next().slideToggle()
  return false
})

$('.recruit-description__menu-02').on('click', function () {
  $(this).addClass('current')
  $('.recruit-description__menu-01').removeClass('current')
  $('.recruit02').show()
  $('.recruit01').hide()
})

$('.recruit-description__menu-01').on('click', function () {
  $(this).addClass('current')
  $('.recruit-description__menu-02').removeClass('current')
  $('.recruit01').show()
  $('.recruit02').hide()
})
/*
$('.reliability__sec02 dt').each(function () {
  $(this).on('click', function () {
    $(this).toggleClass('open')
    $(this).next().slideToggle()
    return false
  })
})
*/

$('.works__sec02__form__inner__btnWrp__btn-clear').on('click', function () {
  $('input[type=radio]').each(function () {
    $(this).prop('checked', false)
  })
})

$('.recruit-description .c-menu01__menu').each(function () {
  $(this).on('click', function () {
    const num = $(this).index('.c-menu01__menu')
    $('.c-menu01__menu').removeClass('current')
    $(this).addClass('current')
    return false
  })
})

$('.news__sec01 .c-menu01__menu').each(function () {
  $(this).on('click', function () {
    const num = $(this).index('.c-menu01__menu')
    $('.news__sec01__contents').removeClass('open')
    $('.news__sec01__contents').eq(num).addClass('open')
    $('.c-menu01__menu').removeClass('current')
    $(this).addClass('current')
    return false
  })
})

$('.product .c-categories li').each(function () {
  $(this).on('click', function () {
    $('.product .c-categories li').removeClass('current')
    $(this).addClass('current')
    const num = $(this).index('.product .c-categories li') + 1
    const categoryName = 'category0' + num
    $('.product__sec03').each(function () {
      $(this).removeClass('current')
      if ($(this).hasClass(categoryName)) {
        $(this).addClass('current')
      }
    })
    return false
  })
})

$(function () {
  let url = location.href
  if (url.match(/description/) && url.match(/tab/)) {
    url = (url.match(/\?id=tab\d+$/) || [])[0]
    const params = url.split('?')
    const tab = params[1].split('=')
    if (tab[1] === 'tab2') {
      $('.recruit01').css({
        display: 'none'
      })
      $('.recruit02').css({
        display: 'block'
      })
      $('.recruit-description__menu-01').removeClass('current')
      $('.recruit-description__menu-02').addClass('current')
    }
  }
})

$('#chkKana').blur(function () {
  hiraChange($(this))
})

function hiraChange (ele) {
  const val = ele.val()
  const hira = val.replace(/[ぁ-ん]/g, function (s) {
    return String.fromCharCode(s.charCodeAt(0) + 0x60)
  })
  if (!val.match(/[ァ-ン]/g)) {
    $(ele).val(hira)
  }
}

$(function () {
  let url = location.href
  if (url.match(/product/) && url.match(/tab/)) {
    url = (url.match(/\?id=tab\d+$/) || [])[0]
    const params = url.split('?')
    const num = params[1].split('=')[1].split('tab')[1]
    $('.product section, .c-categories li').removeClass('current')
    $('.category0' + num).addClass('current')
    $('.c-categories li').eq(num - 1).addClass('current')
  }
})

$('.contact__pp input.check').click(function () {
  if ($(this).prop('checked') === false) {
    $('.form_inputbtn input[type="submit"]').attr('disabled', 'disabled')
  } else {
    $('.form_inputbtn input[type="submit"]').removeAttr('disabled')
  }
})
